import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import { SelectMulti } from "stories/forms";
import { useStoreState, useStoreActions } from 'easy-peasy';

const PrivateInvestmentFundSelect = ({ label, name="private_stock",ratesView, onChange, setFieldValue,defaultValues, value, handleResolve, setFilters }) => {
  const { t } = useTranslation();
  const privateInvestmentFunds = useStoreState((state) => state.privateInvestmentFunds?.objects);
  
  const setLocalFieldValue = (name, obj) => {
    setFieldValue(name, obj?.id)
    setFieldValue("currency", obj?.currency)
    handleResolve({ id: obj?.id, name: obj?.label ? obj?.label : obj?.name })
  }

  // useEffect(() => {

  //   // setLocalFieldValue("private_investment_fund", {label:"David", id:2}
  //   )
  // }, [])

  const getOptions = useCallback(() => {
    return privateInvestmentFunds && privateInvestmentFunds.map(stock => {
      return {value: stock?.id, label: stock?.name, currency: stock?.currency_label}
    })
  }, [privateInvestmentFunds])
  
  const getOptionLabel = useCallback(() => {
    return privateInvestmentFunds && privateInvestmentFunds.reduce((result, obj) => {
      if (obj?.id === value) {
        result = obj?.name
      }
      return result
    }, null)
  }, [privateInvestmentFunds])
  
  /*
  useEffect(() => {
    if (privateInvestmentFunds && privateInvestmentFunds.length > 0 && (value === undefined || value === "")) {
      setLocalFieldValue(name, privateInvestmentFunds[0])
    }
  }, [value, privateInvestmentFunds])
  */
  

  const getDefaultValue = useCallback(() => {
    if (value) {
      //return [value]
      return [{id: value, value: value, label: getOptionLabel()}]
    }
    else if (defaultValues){
      return [defaultValues] ;
      // return undefined;
    }
    // else if (privateInvestmentFunds && privateInvestmentFunds.length > 0) {
    //   console.log(privateInvestmentFunds)
    //   // return [{id: privateInvestmentFunds[0]?.id, value: privateInvestmentFunds[0]?.id, label: privateInvestmentFunds[0]?.name}]
    //   setLocalFieldValue("private_investment_fund", [{id: privateInvestmentFunds[0]?.id, value: privateInvestmentFunds[0]?.id, label: privateInvestmentFunds[0]?.name}])
    // }
    else {
      return undefined;
    }

  }, [privateInvestmentFunds])
  
  return (
  <>
    <SelectMulti
      isMulti={false} 
      name={name} 
      value={value}
      defaultValues={getDefaultValue()}
      setFieldValue={setLocalFieldValue} 
      options={getOptions()} 
      ratesView={ratesView}
    />
  </>
  )

}

export default PrivateInvestmentFundSelect;
